mutation TravelAuthorizationApprovalRevision(
  $input: TravelAuthorizationApprovalRevisionInput!
) {
  travelAuthorizationApprovalRevision(input: $input) {
    clientMutationId
    revisedApprovalEntity
  }
}
